<div
   kendoTooltip
   [tooltipTemplate]="isSkillActiveTooltip"
   filter="input"
   position="right"
   class="sam-center"
   style="min-width: 1.3em"
>
   <div
      *ngIf="!disableLoadingAnimation"
      [ngClass]="(isSkillLoading$ | async) ? 'k-i-loading sam-center' : 'sam-opacity-off no-width'"
   ></div>
   <input
      type="checkbox"
      field="isSkillActive"
      [checked]="
         skillGroup.loggedOnToAllUserIds?.indexOf(userId) > -1 && skillGroup.loggedOnUserIds?.indexOf(userId) > -1
      "
      (click)="changeSkillStatus($event)"
      id="isSkillActive-{{ brickInstanceId }}-{{ skillGroup.skillId }}"
      [disabled]="disabled || !skillGroup.skillUserConfiguration.isManageable"
      [ngClass]="(isSkillLoading$ | async) && !disableLoadingAnimation ? 'sam-opacity-off no-width' : 'k-checkbox'"
      [indeterminate]="
         skillGroup.loggedOnToAllUserIds?.indexOf(userId) === -1 && skillGroup.loggedOnUserIds?.indexOf(userId) > -1
      "
   />
   <label class="k-checkbox-label" for="isSkillActive-{{ brickInstanceId }}-{{ skillGroup.skillId }}"></label>
</div>

<ng-template #isSkillActiveTooltip>
   <div style="align-content: center; margin: 5px" *ngFor="let skill of skillGroup.skills">
      <input
         class="k-checkbox"
         type="checkbox"
         [checked]="skill.loggedOnUserIds?.indexOf(userId) > -1"
         [disabled]="true"
      />
      <label class="k-checkbox-label" for="isSkillActive-{{ brickInstanceId }}-{{ skill.skillId }}"></label>
      {{ skill.skillConfiguration.originName | translate }}
   </div>
</ng-template>
